var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C11.1 34 1 29.6 1 24C1 18.4 11.1 14 24 14C36.9 14 47 18.4 47 24C47 29.6 36.9 34 24 34ZM24 16C11.4 16 3 20.1 3 24C3 27.9 11.4 32 24 32C36.6 32 45 27.9 45 24C45 20.1 36.6 16 24 16Z",
    fill: "url(#paint0_linear_398_32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 44.6C14.1 44.6 13.3 44.4 12.5 43.9C7.59999 41.1 8.89999 30.2 15.3 19C18.3 13.8 22 9.40002 25.6 6.60002C29.5 3.60002 33 2.70002 35.4 4.10002C37.9 5.50002 38.8 9.00002 38.2 13.9C37.6 18.5 35.6 23.9 32.6 29.1C29.6 34.3 25.9 38.7 22.3 41.5C19.7 43.5 17.2 44.6 15.1 44.6ZM32.9 5.40002C31.3 5.40002 29.2 6.30002 26.9 8.10002C23.5 10.8 20 15 17.1 20C10.8 30.9 10.2 40.3 13.5 42.2C15.2 43.2 18 42.3 21.1 39.9C24.5 37.2 28 33 30.9 28C33.8 23 35.7 17.9 36.3 13.6C36.8 9.60002 36.2 6.80002 34.5 5.80002C34 5.60002 33.5 5.40002 32.9 5.40002Z",
    fill: "url(#paint1_linear_398_32)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44.6C28 44.6 20.8 38.5 15.4 29C8.89999 17.8 7.59999 6.90001 12.5 4.10001C17.4 1.30001 26.2 7.80001 32.7 19C35.7 24.2 37.7 29.6 38.3 34.2C39 39.1 38 42.5 35.5 44C34.7 44.4 33.9 44.6 33 44.6ZM13.5 5.80001C10.2 7.70001 10.8 17.1 17.1 28C23.4 38.9 31.2 44.1 34.5 42.2C36.2 41.2 36.8 38.4 36.3 34.4C35.7 30.1 33.8 25 30.9 20C24.6 9.10001 16.8 3.90001 13.5 5.80001Z",
    fill: "url(#paint2_linear_398_32)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z",
    fill: "url(#paint3_linear_398_32)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_32",
    x1: 24,
    y1: 14,
    x2: 24,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FC2CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_32",
    x1: 23.9515,
    y1: 3.45514,
    x2: 23.9515,
    y2: 44.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FC2CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_398_32",
    x1: 24.0243,
    y1: 3.45111,
    x2: 24.0243,
    y2: 44.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FC2CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_398_32",
    x1: 24,
    y1: 20,
    x2: 24,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FC2CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.773b0515c6eab32646e66c2bbc74f4d3.svg";
export { ForwardRef as ReactComponent };